import { render } from "./PolicyRuleTarget.vue?vue&type=template&id=e7baff5a&scoped=true"
import script from "./PolicyRuleTarget.vue?vue&type=script&lang=js"
export * from "./PolicyRuleTarget.vue?vue&type=script&lang=js"

import "./PolicyRuleTarget.vue?vue&type=style&index=0&id=e7baff5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7baff5a"]])

export default __exports__